import React from 'react';
import styled, { keyframes } from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';

const wave = keyframes`
  0%, 40%, 100% {
    transform: scaleY(0.6);
  }
  20% {
    transform: scaleY(1);
  }
`;

const Container = styled(Box).attrs({
  horizontal: true,
  width: '100%',
  justify: 'center',
})`
  height: 60px;
`;

const Bars = styled(Box).attrs({
  horizontal: true,
  justify: 'space-between',
  width: '27px',
})`
  height: 30px;
`;

const Bar = styled.div`
  display: inline-block;
  width: 3px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.primaryBase};
  animation: ${wave} 1.2s infinite ease-in-out;
  &:nth-child(1) {
    animation-delay: -1.2s;
  }
  &:nth-child(2) {
    animation-delay: -1.1s;
  }
  &:nth-child(3) {
    animation-delay: -1s;
  }
  &:nth-child(4) {
    animation-delay: -0.9s;
  }
  &:nth-child(5) {
    animation-delay: -0.8s;
  }
`;

export const Loader = () => (
  <Container>
    <Bars>
      <Bar />
      <Bar />
      <Bar />
      <Bar />
      <Bar />
    </Bars>
  </Container>
);

export default Loader;
